import { render } from "./ProposalRow.vue?vue&type=template&id=2fbd6ebe&scoped=true&ts=true"
import script from "./ProposalRow.vue?vue&type=script&lang=ts"
export * from "./ProposalRow.vue?vue&type=script&lang=ts"

import "./ProposalRow.vue?vue&type=style&index=0&id=2fbd6ebe&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fbd6ebe"]])

export default __exports__